import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Button, Spinner } from "react-bootstrap";
import { getAllBerita, BASE_URL } from "../services/api";
import "./LayananDetail.css";

const LayananDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [layanan, setLayanan] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    fetchLayananDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const fetchLayananDetail = async () => {
    try {
      setLoading(true);
      const response = await getAllBerita();
      if (response.data.success) {
        const foundLayanan = response.data.data.find(
          (item) => item.id === parseInt(id),
        );
        if (
          foundLayanan &&
          foundLayanan.jenisberita !== "berita" &&
          foundLayanan.jenisberita !== "welcome"
        ) {
          setLayanan(foundLayanan);
        } else {
          setError(true);
        }
      }
    } catch (error) {
      console.error("Error fetching layanan:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const getIconClass = (jenisberita) => {
    const iconMap = {
      sertifikasi: "fas fa-certificate",
      pendampingan: "fas fa-user-check",
      edukasi: "fas fa-book-open",
      konsultasi: "fas fa-headset",
    };
    return iconMap[jenisberita] || "fas fa-cogs";
  };

  if (loading) {
    return (
      <div className="layanan-detail-loading">
        <Container>
          <div className="text-center py-5">
            <Spinner animation="border" variant="primary" />
            <p className="mt-3">Memuat layanan...</p>
          </div>
        </Container>
      </div>
    );
  }

  if (error || !layanan) {
    return (
      <div className="layanan-detail-error">
        <Container>
          <div className="text-center py-5">
            <i className="fas fa-exclamation-triangle fa-3x text-warning mb-3"></i>
            <h3>Layanan Tidak Ditemukan</h3>
            <p className="text-muted mb-4">
              Maaf, layanan yang Anda cari tidak tersedia.
            </p>
            <Button variant="primary" onClick={() => navigate("/")}>
              <i className="fas fa-home me-2"></i>
              Kembali ke Beranda
            </Button>
          </div>
        </Container>
      </div>
    );
  }

  return (
    <div className="layanan-detail-page">
      <Container>
        <Row className="justify-content-center">
          <Col lg={10} xl={8}>
            {/* Breadcrumb */}
            <nav aria-label="breadcrumb" className="layanan-breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Button
                    variant="link"
                    className="p-0"
                    onClick={() => navigate("/")}
                  >
                    <i className="fas fa-home me-1"></i>
                    Beranda
                  </Button>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  {layanan.judul}
                </li>
              </ol>
            </nav>

            {/* Layanan Header */}
            <div className="layanan-header">
              <div className="layanan-icon-large">
                {layanan.foto ? (
                  <img
                    src={`${BASE_URL}/uploads/${layanan.foto}`}
                    alt={layanan.judul}
                    className="layanan-icon-img"
                  />
                ) : (
                  <i className={getIconClass(layanan.jenisberita)}></i>
                )}
              </div>
              <h1 className="layanan-title">{layanan.judul}</h1>
              {layanan.ringkasan && (
                <p className="layanan-summary">{layanan.ringkasan}</p>
              )}
            </div>

            {/* Layanan Content */}
            <div className="layanan-content">
              <div
                className="layanan-body"
                dangerouslySetInnerHTML={{ __html: layanan.isiberita }}
              />
            </div>

            {/* Back Button */}
            <div className="layanan-footer">
              <Button
                variant="outline-primary"
                onClick={() => navigate("/")}
                className="btn-back"
              >
                <i className="fas fa-arrow-left me-2"></i>
                Kembali ke Beranda
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LayananDetail;
